import React from 'react';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap/lib';

function NumberInput({
  formData,
  name,
  label,
  onChange,
  min,
  max,
  info,
  isRequired,
}) {
  isRequired = isNil(isRequired) ? true : isRequired;
  return (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <FormControl
        name={name}
        type="number"
        value={get(formData, name)}
        onChange={onChange}
        min={min || 0}
        max={max || 50}
        required={isRequired}
      />
      <span className="info">{info}</span>
    </FormGroup>
  );
}

NumberInput.propTypes = {
  formData: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  info: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  isRequired: PropTypes.bool,
};

export default NumberInput;
